import { useEffect, useState } from "react"

export function useStateWithLocalStorage(localStorageKey) {
  const [value, setValue] = useState(localStorage.getItem(localStorageKey) || '')

  useEffect(() => {
    localStorage.setItem(localStorageKey, value)
  }, [value])
  return [value, setValue]
}
